/**
 * Checks if the Swiper instance has navigation elements.
 * @param {Object} swiper - The Swiper instance.
 * @returns {boolean} True if navigation elements are present, false otherwise.
 */
const hasNavigation = (swiper) => {
  return swiper?.navigation?.nextEl && swiper?.navigation?.prevEl;
};

/**
 * Checks if the Swiper instance has pagination elements.
 * @param {Object} swiper - The Swiper instance.
 * @returns {boolean} True if pagination elements are present, false otherwise.
 */
const hasPagination = (swiper) => {
  return swiper?.pagination?.bullets?.length > 0;
};

/**
 * Checks if the Swiper instance has a scrollbar.
 * @param {Object} swiper - The Swiper instance.
 * @returns {boolean} True if a scrollbar is present, false otherwise.
 */
const hasScrollbar = (swiper) => {
  return swiper?.scrollbar?.el;
};

export { hasNavigation, hasPagination, hasScrollbar };
